import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { MemberService } from "../services/member.service";
import { RouteHelperService } from "../../core/services/route-helper.service";
import { config } from "../../app.config";
import { AuthDataStorageService } from "../../auth/services/auth-data-storage.service";
import { PageParamStorageService } from "../../core/services/page-param-storage.service";
import { RequestNewIdReason } from "../members.interfaces";
import { Subject } from "rxjs";
import { first } from "rxjs/operators";
const alertify = require("alertify.js");
import { Title } from '@angular/platform-browser';

@Component({
  selector: "ch-member-list",
  templateUrl: "./member-list.component.html",
  styleUrls: ["./member-list.component.less"]
})
export class MemberListComponent implements OnInit, OnDestroy {
  public previewData: any;
  public items = [];
  public totalItems;
  public pageParams: any = {};
  public showDialog: boolean;
  public showPreviewDialog = false;
  public showMassNewProofDialog = false;
  public showInvalidPlanDialog = false;
  public selectedItems: Array<number> = [];
  public membersToBeActioned: Array<any> = [];
  public selectOptions: any[];
  public promoCodes: any;
  public loading: boolean;
  public massActionInProgress: boolean;
  public exportingExcel: boolean;
  public token: any;
  public showExportDialog = false;

  private filterFields: string[] = ["search", "type", "pageSize"];
  private unsubscribe$: Subject<any> = new Subject<any>();

  constructor(
    private memberService: MemberService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private routeHelperService: RouteHelperService,
    private authDataStorageService: AuthDataStorageService,
    private pageParamStorageService: PageParamStorageService,
    private titleService: Title,
  ) {
    this.token = this.authDataStorageService.getSessionTokenFromStorage();
    this.selectOptions = this.memberService.getMemberStatuses();
    this.massActionInProgress = false;
    alertify.logPosition("bottom right");
  }

  ngOnInit() {
    this.titleService.setTitle(`Members | CODE Hospitality CMS`);
    this.loadMembers();
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
    this.unsubscribe$.next(null);
    this.unsubscribe$.unsubscribe();
  }

  loadMembers() {
    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe(params => {
        this.showDialog = false;
        this.selectedItems = [];

        if (
          Object.keys(params).length === 0 &&
          this.pageParamStorageService.pageParams
        ) {
          params = this.pageParamStorageService.pageParams;
          this.queryParams(params);
        }

        this.pageParams = this.routeHelperService.getValidatedParams(params);
        this.pageParams = this.getFilteredPageParams(this.pageParams);
        this.loadItems(this.pageParams);
        this.pageParamStorageService.pageParams = this.pageParams;
      });

  }

  private getFilteredPageParams(params: any) {
    const result = { ...params };
    if (params && !params.sortBy) {
      result.sortBy = "SIGNED_UP";
      result.sortOrder = "DESC";
    }

    return result;
  }

  public massSelect(checked) {
    if (!checked) {
      this.clearSelectedItems();
    } else {
      this.selectAll();
    }
  }

  public selectAll() {
    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i];
      item.checked = true;
      this.check(i, true);
    }
  }

  public check(index: number, checked?: boolean) {
    if (checked) {
      this.selectedItems.push(index);
    } else {
      for (let i = 0; i < this.selectedItems.length; i++) {
        if (this.selectedItems[i] === index) {
          this.selectedItems.splice(i, 1);
          break;
        }
      }
    }
  }


  public typeChanged(event) {
    const value = event.target.value;
    this.filterSearch({
      type: value
    });
  }

  public search(event) {
    this.filterSearch({
      search: event
    });
  }

  public clearFilters() {
    this.pageParams = { pageSize: this.pageParams.pageSize };
    this.pageParamStorageService.pageParams = this.pageParams;
    this.filterSearch({});
  }

  private filterSearch(data) {
    const result = {};
    for (const i of this.filterFields) {
      result[i] = null != data[i] ? data[i] : this.pageParams[i];
    }

    this.router.navigate([], { queryParams: result });
  }

  public onSort(data) {
    this.queryParams({
      sortBy: data.column,
      sortOrder: data.order
    });
  }

  public onPageChanged(page) {
    this.queryParams({
      pageNumber: page.pageNumber,
      pageSize: page.pageSize
    });
  }

  private queryParams(params) {
    const result = this.routeHelperService.queryParams(params, this.pageParams);
    this.router.navigate([], { queryParams: result });
  }

  private loadItems(data) {
    this.loading = true;
    this.memberService.getMembers(data).subscribe(result => {
      const jsonData = result.json();
      this.items = jsonData.items;
      this.totalItems = jsonData.totalItems;
      this.loading = false;
    });
  }

  public massAccept(): void {
    if (this.massActionInProgress) {
      return;
    }
    this.massActionInProgress = true;

    const selected = this.getSelectedItems();

    this.memberService
      .bulkAcceptMembers(selected)
      .subscribe(_ => this.comlpeteBulkOperation());
  }

  public massRequestNewId(type: RequestNewIdReason): void {
    if (this.massActionInProgress) {
      return;
    }
    this.massActionInProgress = true;

    const selected = this.getSelectedItems();

    this.memberService
      .bulkRequestNewIds(selected, type)
      .subscribe(_ => this.comlpeteBulkOperation());
  }

  public massReject(): void {
    if (this.massActionInProgress) {
      return;
    }
    this.massActionInProgress = true;

    const selected = this.getSelectedItems();

    this.memberService
      .bulkRejectMembers(selected)
      .subscribe(_ => this.comlpeteBulkOperation());
  }

  public massCancelSubscriptionEndOfPeriod(): void {
    if (this.massActionInProgress) {
      return;
    }
    this.massActionInProgress = true;

    const selected = this.getSelectedItems();

    this.memberService
      .bulkCancelSubscriptionsEndOfPeriod(selected).pipe(first()).subscribe(() => {
        alertify.success(`Subscriptions marked for cancelling at end of the subscription period.`);
        this.comlpeteBulkOperation();
      }, err => {
        this.loading = false;
        this.massActionInProgress = false;
        this.alertError(err);
      });
  }

  public massCancelSubscriptionNow(): void {
    if (this.massActionInProgress) {
      return;
    }
    this.massActionInProgress = true;

    const selected = this.getSelectedItems();

    this.memberService
      .bulkCancelSubscriptionsNow(selected).pipe(first()).subscribe(() => {
        alertify.success(`Subscriptions cancelled successfully.`);
        this.comlpeteBulkOperation();
      }, err => {
        this.loading = false;
        this.massActionInProgress = false;
        this.alertError(err);
      });
  }

  public massRemoveVIP(): void {
    if (this.massActionInProgress) {
      return;
    }
    this.massActionInProgress = true;

    const selected = this.getSelectedItems();

    this.memberService
      .bulkRemoveVIP(selected).pipe(first()).subscribe(() => {
        alertify.success(`VIP status removed`);
        this.comlpeteBulkOperation();
      }, err => {
        this.loading = false;
        this.massActionInProgress = false;
        this.alertError(err);
      });
  }

  private comlpeteBulkOperation() {
    this.clearSelectedItems();
    this.loadItems(this.pageParams);
    this.massActionInProgress = false;
  }

  private getSelectedItems(): string[] {
    return this.selectedItems
      .map(index => {
        return this.items[index];
      })
      .map(user => {
        return user.id;
      });
  }


  private alertError(error): void {
    alertify.error(
      `There was a ${error.status} error with message '${error.error}'.`
    );
  }

  private alertSuccess(method): void {
    alertify.success(
      `Successfully ${method} members.`
    );
  }

  private clearSelectedItems() {
    this.showDialog = false;
    this.selectedItems = [];
    this.items.forEach(item => {
      item.check = false;
    });
  }

  public massActions() {
    this.showDialog = 0 < this.selectedItems.length;
  }

  public onClose() {
    this.showDialog = false;
  }

  public onCloseMassNewProof() {
    this.showMassNewProofDialog = false;
  }

  public onCloseInvalidPlanDialog() {
    this.showInvalidPlanDialog = false;
  }

  public onClosePreview() {
    this.showPreviewDialog = false;
  }

  public onActionSelected(value) {
    switch (value) {
      case "accept":
        this.massAccept();
        break;
      case "request_new_id":
        this.showMassNewProofDialog = true;
        break;
      case "reject":
        this.massReject();
        break;
      case "cancel_subscription_now":
        this.massCancelSubscriptionNow();
        break;
      case "cancel_subscription_end_of_period":
        this.massCancelSubscriptionEndOfPeriod();
        break;
      case "remove_vip":
        this.massRemoveVIP();
        break;
    }
  }

  public onPreviewActionSelected(value: RequestNewIdReason | string): void {
    this.loading = true;
    const { response, status } = this.executePreviewAction(value);

    response.subscribe(
      _ => {
        this.loading = false;
        this.handleStatusChanged(this.previewData.id, status);
        alertify.success("Request successful");
      },
      (error: any) => {
        this.loading = false;
        if (error.status == 400 && error.error.startsWith("Couldn't find product plan")) {
          this.showInvalidPlanDialog = true;
        } else {
          alertify.error(
            `Something gone wrong! There was a ${error.status} error with message '${error.error}'.`
          );
        }
      }
    );
  }

  private handleStatusChanged(id: string, newStatus: string): void {
    const index = this.findIndexById(id);

    if (this.pageParams.type && newStatus != this.pageParams.status) {
      this.items.splice(index, 1);
    } else {
      this.items[index].status = newStatus;
    }
  }

  private findIndexById(id: string): any {
    for (let index = 0; index < this.items.length; index++) {
      const element = this.items[index];
      if (element.id === id) {
        return index;
      }
    }
    return -1;
  }

  private executePreviewAction(value: RequestNewIdReason | string): any {
    switch (value) {
      case "accept":
        return {
          response: this.memberService.acceptMember(this.previewData.id),
          status: "APPROVED"
        };
      case "reject":
        return {
          response: this.memberService.rejectMember(this.previewData.id),
          status: "REJECTED"
        };
      case RequestNewIdReason.INVALID_PROOF:
        return {
          response: this.memberService.requestNewId(
            this.previewData.id,
            RequestNewIdReason.INVALID_PROOF
          ),
          status: "WAITING_FOR_PROOF"
        };
      case RequestNewIdReason.MISSING_PROOF:
        return {
          response: this.memberService.requestNewId(
            this.previewData.id,
            RequestNewIdReason.MISSING_PROOF
          ),
          status: "WAITING_FOR_PROOF"
        };
      case RequestNewIdReason.OUTDATED_PROOF:
        return {
          response: this.memberService.requestNewId(
            this.previewData.id,
            RequestNewIdReason.OUTDATED_PROOF
          ),
          status: "WAITING_FOR_PROOF"
        };
    }
  }

  public preview(data: any): void {
    this.showPreviewDialog = true;
    this.previewData = {
      id: data.id,
      title:
        data.firstName +
        " " +
        data.lastName +
        ", " +
        data.jobTitle +
        " at " +
        data.employer,
      resourceId: data.proofResourceId
    };
  }

  public isNotValidStatus(targetStatus: string) {
    const statuses = this.memberService.getMemberStatuses();
    for (const status of statuses) {
      if (status.value === targetStatus) {
        return false;
      }
    }

    return true;
  }

  public isSuccessStatus(status: string) {
    return (
      status === "VIP" ||
      status === "FREE_TRIAL" ||
      status === "FREE" ||
      status === "PAID_MEMBER" ||
      status === "APPROVED"
    );
  }

  public isDangerStatus(status: string) {
    return (
      status === "REJECTED" ||
      status === "SUSPENDED" ||
      status === "NON_RENEWAL" ||
      status === "FAILED_PAYMENT"
    );
  }

  public isTrialEndedStatus(status: string) {
    return status === "FREE_TRIAL_ENDED";
  }

  public isWarningStatus(status: string) {
    return (
      status === "WAITING_FOR_VERIFICATION" ||
      status === "WAITING_FOR_PROFILE" ||
      status === "WAITING_FOR_PAYMENT" ||
      status === "WAITING_FOR_PROOF" ||
      status === "WAITING_FOR_APPROVAL"
    );
  }

  public getStatusLabel(status: string) {
    for (const i of this.memberService.getMemberStatuses()) {
      if (i.value === status) {
        return i.name;
      }
    }
    return "";
  }

  public getRegistrationStatusLabel(status: string) {
    for (const i of this.memberService.getMemberRegistrationStatuses()) {
      if (i.value === status) {
        return i.name;
      }
    }
    return "";
  }

  public downloadReportModal(): void {
    this.showExportDialog = true;
    this.exportingExcel = true;
  }

  public onCloseExportDialog(): void {
    this.showExportDialog = false;
    this.exportingExcel = false;
  }

  public onExport(data) {
    const query: string = "?" + this.queryString + "&recipient=" + data.email;
    this.memberService.exportUrl(query).subscribe(
      r =>
        alertify.success(
          "Request successful, email will be received within 5 minutes"
        ),
      e =>
        alertify.error(
          "Something gone wrong, please enter valid email and try again!"
        )
    );
  }

  get hasSelectedItems() {
    return this.selectedItems instanceof Array && 0 < this.selectedItems.length;
  }

  get apiUrl() {
    return config.api_url;
  }

  get queryString() {
    return this.routeHelperService.buildQueryString(
      {
        "x-auth-token": this.authDataStorageService.getSessionTokenFromStorage(),
        ...this.pageParams
      },
      ["pageSize", "pageNumber"]
    );
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/member/member-list/member-list.component.ts